import React from 'react';

/** 仅提供列表区外层背景容器（Shopify 站自带 header/footer，此处不做） */
export default function OrdersChrome({ children }) {
  return <div className="orders-layout-app">{children}</div>;
}



// WEBPACK FOOTER //
// ./src/js/components/ordersLayout/OrdersChrome.jsx